import React from 'react';
import ReactPaginate from 'react-paginate';
import Skeleton from 'react-loading-skeleton';

const Pagination = ({ curpage, totalpages, totalresults, args=[], handler, loading, activeText, border, marginTop='mt-6 py-3' }) => {
  const handlePageClick = (number) => {
    // selected page = number.selected + 1
    handler(number.selected, ...args);
  };

  if (loading) {
    return (
      <div className='mt-6 py-3 flex items-center justify-between border-gray-200'>
        <Skeleton width={200} height={30} />
        <Skeleton width={200} height={30} />
      </div>
    );
  }

  return (
    <div className={` flex items-center justify-between border-gray-200 ${marginTop}`}>
      <div className='hidden sm:flex-1 sm:flex sm:items-center sm:justify-between'>
        <div>
          <p className='text-base text-gray-700 m-0'>
            Showing
            <span className='font-semibold mx-1'>{ totalresults === 0 ? 0 : curpage * 10 + 1}</span>
            to
            <span className='font-semibold mx-1'>
              { curpage * 10 + 10 <= totalresults ? curpage * 10 + 10 : totalresults }
            </span>
            of
            <span className='font-semibold mx-1'>{totalresults}</span>
            results
          </p>
        </div>
        <div>
          <ReactPaginate
            forcePage={curpage}
            previousLabel={
              <span className={`relative inline-flex items-center px-2 py-2 rounded-l-md border  text-sm font-semibold text-gray-500 hover:bg-gray-50 cursor-pointer ${border ? border : 'border-gray-300'}`}>
                <span className='sr-only'>Previous</span>
                <svg
                  className='h-5 w-5'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 20 20'
                  fill='currentColor'
                  aria-hidden='true'
                >
                  <path
                    fillRule='evenodd'
                    d='M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z'
                    clipRule='evenodd'
                  />
                </svg>
              </span>
            }
            nextLabel={
              <span className={`relative inline-flex items-center px-2 py-2 rounded-r-md border text-sm font-semibold text-gray-500 hover:bg-gray-50 cursor-pointer ${border ? border : 'border-gray-300'}`}>
                <span className='sr-only'>Next</span>
                <svg
                  className='h-5 w-5'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 20 20'
                  fill='currentColor'
                  aria-hidden='true'
                >
                  <path
                    fillRule='evenodd'
                    d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z'
                    clipRule='evenodd'
                  />
                </svg>
              </span>
            }
            pageCount={totalpages}
            onPageChange={handlePageClick}
            containerClassName={`relative z-0 inline-flex rounded-md -space-x-px`}
            activeLinkClassName={`text-blue-600 ${activeText}`}
            pageLinkClassName={
              `relative inline-flex items-center px-4 py-2 border   text-sm font-semibold text-gray-500 hover:bg-gray-50 cursor-pointer ${border ? border : 'border-gray-300'}`
            }
            breakClassName={
              `relative inline-flex items-center px-4 py-2 border  text-sm font-semibold text-gray-500 hover:bg-gray-50 cursor-pointer  ${border ? border : 'border-gray-300'}`
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Pagination;
